import { useState, createContext, useContext } from 'react';
import { generateId } from 'app/admin/whatIf/component/WhatIfUtil';

export const GridContext = createContext(null);

export const useGrid = () => {
	return useContext(GridContext);
};

export default function GridProvider(props) {
	const { field } = props;
	const [grid, setGrid] = useState(null);

	const addRow = () => {
		const item = { key: generateId(), name: null };
		setGrid({
			...grid,
			rows: [...grid.rows, item],
			[field]: [
				...grid[field],
				...grid.columns.map(c => {
					return {
						key: generateId(),
						row: item.key,
						column: c.key,
						value: null
					};
				})
			]
		});
	};

	const changeRowName = (key, value) => {
		setGrid({
			...grid,
			rows: grid.rows.map(d => {
				if (d.key === key) {
					return {
						...d,
						name: value
					};
				}
				return d;
			})
		});
	};

	const removeRow = index => {
		const row = grid.rows[index];
		setGrid({
			...grid,
			rows: grid.rows.filter((d, i) => i !== index),
			[field]: grid[field].filter(c => c.row !== row.key)
		});
	};

	const addColumn = () => {
		console.log(grid);
		console.log(field);
		const item = { key: generateId(), name: null };
		setGrid({
			...grid,
			columns: [...grid.columns, item],
			[field]: [
				...grid[field],
				...grid.rows.map(r => {
					return {
						key: generateId(),
						row: r.key,
						column: item.key,
						value: null
					};
				})
			]
		});
	};

	const removeColumn = index => {
		const column = grid.columns[index];
		setGrid({
			...grid,
			columns: grid.columns.filter((d, i) => i !== index),
			[field]: grid[field].filter(c => c.column !== column.key)
		});
	};

	const changeColumnName = (key, value) => {
		setGrid({
			...grid,
			columns: grid.columns.map(d => {
				if (d.key === key) {
					return {
						...d,
						name: value
					};
				}
				return d;
			})
		});
	};

	const changeValue = (type, key, value) => {
		setGrid({
			...grid,
			[type]: grid[type].map(d => {
				if (d.key === key) {
					return {
						...d,
						value
					};
				}
				return d;
			})
		});
	};

	const value = {
		grid,
		setGrid,
		addRow,
		removeRow,
		changeRowName,
		addColumn,
		removeColumn,
		changeColumnName,
		changeValue
	};

	return <GridContext.Provider value={value}>{props.children}</GridContext.Provider>;
}
